import script from "./HeaderAllezchantez.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderAllezchantez.vue?vue&type=script&setup=true&lang=js"

import "./HeaderAllezchantez.vue?vue&type=style&index=0&id=5db60cc2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db60cc2"]])

export default __exports__